<template>
  <material-card
    :title="title"
    data-testId="material-card-title"
    color="dover-blue">
    <v-form
      ref="form"
      v-model="isValidationOk"
      lazy-validation>
      <v-container
        py-0>
        <v-layout
          wrap>
          <v-flex
            xs12
            md12>
            <v-data-table
              :headers="headers"
              :items="notificationsData"
              :no-data-text="`${ Maglink.NoDataMessage(false) }`"
              :no-results-text="`${ Maglink.NoDataMessage(true) }`"
              data-testId="data-table"
              hide-actions>
              <template
                slot="headerCell"
                slot-scope="{ header }">
                <span
                  data-testId="header-text"
                  class="dover-light-blue-color"
                  v-text="header.text" />
              </template>
              <template
                slot="items"
                slot-scope="{ item }">
                <tr :data-testId="'row-' + `${ Maglink.IdFormat(item.name) }`">
                  <td
                    data-testId="item-name"
                    nowrap >{{ $t(item.name) }}</td>
                  <td
                    data-testId="item-hour"
                    class="text-xs-left"
                    width="10%">
                    <v-select
                      v-if="isVisible(item)"
                      v-model="item.hour"
                      :items="hours"
                      data-testId="select-desc"
                      item-value="code"
                      item-text="desc"
                      box/>
                  </td>
                  <td
                    data-testId="item-email"
                    width="10%">
                    <v-switch
                      v-if="isEmailVisible(item)"
                      v-model="item.email"
                      data-testId="item-switch"
                      class="dover-input"/>
                  </td>
                  <td
                    data-testId="item-print"
                    width="10%">
                    <v-switch
                      v-if="isPrintVisible(item)"
                      v-model="item.print"
                      data-testId="item-switch-2"
                      class="dover-input"/>
                  </td>
                  <td data-testId="item-contacts">
                    <v-combobox
                      v-model="item.contacts"
                      :items="contactsData"
                      :label="`${ $t('Contact list') }`"
                      data-testId="combobox-Contact-list"
                      item-text="name"
                      item-value="id"
                      chips
                      clearable
                      solo
                      multiple>
                      <template v-slot:item="{ item }">
                        <v-list-item :data-testid="`dropdown-item-`+`${ Maglink.IdFormat(item.name) }`">
                          <v-list-item-content>{{ item.name }}</v-list-item-content>
                        </v-list-item>
                      </template>
                      <template
                        slot="selection"
                        slot-scope="data">
                        <v-chip
                          :selected="data.selected"
                          :data-testId="`item-`+`${ Maglink.IdFormat(data.item.name) }`"
                          close>
                          <strong>{{ data.item.name }}</strong>&nbsp;
                        </v-chip>
                      </template>
                    </v-combobox>
                  </td>
                </tr>
              </template>
            </v-data-table>
          </v-flex>
          <v-flex
            xs12
            md12
            text-xs-right>
            <v-btn
              :disabled="!isValidationOk || !Maglink.IsAdminUser()"
              data-testId="btn-Save"
              small
              class="mx-0 font-weight-light"
              color="dover-blue"
              @click="save">
              {{ $t('Save') }}
            </v-btn>
          </v-flex>
        </v-layout>
      </v-container>
    </v-form>
  </material-card>
</template>

<script>
import { i18n } from '@/i18n'
import Vue from 'vue'

export default {
  props: {
    title: {
      type: String,
      required: true
    },
    contactsData: {
      type: Array,
      required: true,
      default: () => []
    },
    notificationsData: {
      type: Array,
      required: true,
      default: () => []
    }
  },
  data: () => ({
    isValidationOk: false,
    rules: {
      required: [ v => Vue.prototype.Maglink.RulesRequired(v) ],
      max30: [ v => Vue.prototype.Maglink.RulesMaxLen(v, 2) ]
    },
    hours: [],
    headers: [
      { sortable: false, text: i18n.t('Event') },
      { sortable: false, text: '' }, // TODO automatic inventory i18n.t('Hour') },
      { sortable: false, text: i18n.t('Email') },
      { sortable: false, text: i18n.t('Print') },
      { sortable: false, text: i18n.t('Contacts') }
    ],
    emailKeys: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 12],
    printKeys: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 12]
  }),
  mounted () {
    for (let hour = 1; hour < 25; hour++) {
      this.hours.push({ code: hour, desc: this.formatHour(hour) })
    }
  },
  updated () {
    this.notificationsData.forEach(item => {
      if (item.name === 'Stock') {
        item.name = 'Current inventory'
      }
      if (!this.isItemVisible(item)) {
        this.notificationsData.splice(this.notificationsData.indexOf(item), 1)
      }
    })
  },
  methods: {
    formatHour (hour) {
      let value = this.Maglink.RoundFormat(hour, 2)
      if (hour < 10) {
        value = '0' + value
      }
      return value
    },
    isVisible (item) {
      return false // TODO automatic inventory tem.key === 4
    },
    isEmailVisible (item) {
      return this.emailKeys.indexOf(item.key) > -1
    },
    isPrintVisible (item) {
      return this.printKeys.indexOf(item.key) > -1
    },
    isItemVisible (item) {
      if (item.key === 0) {
        return false
      }
      if (!Vue.prototype.Maglink.isPlus && (item.key === 8 || item.key === 9 || item.key === 10)) { // LLD
        return false
      }
      return true
    },
    save (event) {
      if (this.$refs.form.validate()) {
        this.isValidationOk = true
        this.$emit('notificationsSaved')
      } else {
        this.isValidationOk = false
      }
    },
    snack (color, message) {
      message = this.title + ': ' + message
      this.$store.dispatch('showSnackbar', { color, message, show: true })
    }
  }
}
</script>
